<i
  class="fas"
  [class.fa-check]="checked"
  [class.new-color]="checked"
  [class.fa-times]="!checked"
  [class.danger-color]="!checked" >

</i>
